export enum ReactionEnum{
    Recommend="1",
    Celebrate="2",
    Love="3",
    Interesting="4",
    Curious="5"
}
